export default function AboutSection() {
  return (
    <section id="about-section" className="py-32 bg-white relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-pink-100 to-purple-100 rounded-full blur-3xl opacity-30"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gradient-to-tr from-cyan-100 to-indigo-100 rounded-full blur-3xl opacity-30"></div>

      <div className="max-w-6xl mx-auto px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">私のストーリーと情熱</h2>
          <div className="w-32 h-1 bg-gradient-to-r from-pink-500 to-cyan-500 rounded-full mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://storage.readdy-site.link/project_files/ad497236-385f-4b6e-bb69-bc2f03e1f0bd/c55c316b-df3a-40ae-bf91-706083888bce_Image_1y0z411y0z411y0z.jpg?v=cb9241a0db09ca454827f81c34e276f4"
                alt="ダニエル・ロサノのワークスペース"
                className="w-full h-auto object-cover object-top"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="space-y-8">
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 to-rose-500 rounded-xl flex-shrink-0">
                  <i className="ri-graduation-cap-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">学術的基盤</h3>
                  <p className="text-gray-700 leading-relaxed">
                    <strong>デジタルイラストレーションの修士号</strong>と<strong>グラフィックデザインの学士号</strong>を取得しています。この二重の背景により、本当に際立つ素晴らしい<span className="san-brainy">vtuber</span>アセットを作成するために必要な芸術的ビジョンと技術的精度の両方を持っています。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-purple-500 to-indigo-500 rounded-xl flex-shrink-0">
                  <i className="ri-global-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">文化の架け橋</h3>
                  <p className="text-gray-700 leading-relaxed">
                    <strong>スペイン語、英語、日本語</strong>に堪能で、日本で生活し学ぶ素晴らしい機会を得ました。この経験により、VTubingとアニメを生み出した文化への深い洞察を得ることができました。これは私にとって単なる仕事ではなく、毎日生き、呼吸している情熱なのです。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-blue-500 rounded-xl flex-shrink-0">
                  <i className="ri-heart-fill text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">心からの<span className="san-brainy">Vtuber</span>愛好家</h3>
                  <p className="text-gray-700 leading-relaxed">
                    私は単なるデザイナーではありません。<strong>情熱的な{'\u00A0'}<span className="san-brainy">vtuber</span>ファン</strong>です。初期の頃からシーンを追いかけ、ニッチな日本の配信からグローバルな現象へと進化するのを見てきました。私がこのコミュニティの一員であるため、ファンがお気に入りの{'\u00A0'}<span className="san-brainy">vtuber</span>とつながる理由を理解しています。このインサイダーの視点は、ファンダムに真に響き、VTubingをユニークにする特別な魔法を捉えるデザインを作成するのに役立ちます。
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-teal-500 to-emerald-500 rounded-xl flex-shrink-0">
                  <i className="ri-lightbulb-flash-line text-xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">私のデザイン哲学</h3>
                  <p className="text-gray-700 leading-relaxed">
                    すべての{'\u00A0'}<span className="san-brainy">vtuber</span>には語るべきユニークなストーリーがあり、私の仕事は、注目を集め、コミュニティを構築し、永続的な印象を作り出すビジュアルを通じて、そのストーリーに命を吹き込むことです。デビューパッケージでも完全なリブランディングでも、これらのキャラクターがクリエイターとファンの両方にとってどれほど意味があるかを知っているので、すべてのプロジェクトに心を注いでいます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}